import { trackGtmEvent } from './gtm-data-layer'

export const GTM = 'gtm'

export const GTM_EVENTS = {
  avantLinkPurchase: 'avantLinkPurchase',
  gtmEvent: 'gtmEvent',
  gtmInfo: 'gtmInfo',
  gtmEcomPromotionView: 'gtmEcomPromotionView',
  gtmEcomPromotionClick: 'gtmEcomPromotionClick',
  gtmEcomProductImpression: 'gtmEcomProductImpression',
  gtmEcomProductClick: 'gtmEcomProductClick',
  gtmEcomDetailView: 'gtmEcomDetailView',
  gtmEcomAddToCart: 'gtmEcomAddToCart',
  gtmEcomRemoveFromCart: 'gtmEcomRemoveFromCart',
  gtmEcomCheckout: 'gtmEcomCheckout',
  gtmEcomCheckoutOption: 'gtmEcomCheckoutOption',
  gtmEcomPurchase: 'gtmEcomPurchase',
  gtmVirtPath: 'gtmVirtPath',
  rockerBoxCheckout: 'rockerBoxCheckout',
  rockerBoxPurchase: 'rockerBoxPurchase',
}

export const GTM_EVENT_CATEGORIES = {
  errors: 'errors',
  filterSorting: 'filter_and_sorting',
  navigation: 'navigation',
  notification: 'notification',
  productInteractions: 'product_interactions',
  quiz: 'quiz',
  shoeComparison: 'shoe_comparison',
  shoeFinder: 'shoe_finder',
  shoeMatcher: 'shoe_matcher',
  sizeGuide: 'size_guide',
  subscriptions: 'subscriptions',
  survey: 'survey',
  userAccount: 'user_account',
}

export const GTM_EVENT_ACTIONS = {
  backorderable_popup: 'backorderable_popup',
  non_backorderable_popup: 'non_backorderable_popup',
}

export const GTM_EVENT_LABELS = {
  open: 'open',
  subscribed: 'subscribed',
  back_in_stock_notification: 'back_in_stock_notification',
}

const gtmEventHandlers = {}

Object.values(GTM_EVENTS).forEach(event => {
  gtmEventHandlers[event] = (event, eventPayload) => trackGtmEvent(event, eventPayload)
})

export default gtmEventHandlers
